import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Mail } from "lucide-react";

export default function UnsubscribePage() {
  const { token } = useParams();
  const [contact, setContact] = useState(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/email/unsubscribe/${token}`)
      .then(({ data }) => { setContact(data.contact); setDone(!!data.contact?.unsubscribed); })
      .catch((e) => setErr(e?.response?.data?.detail || "Invalid link"))
      .finally(() => setLoading(false));
  }, [token]);

  const confirm = async () => {
    try {
      await api.post(`/email/unsubscribe/${token}`);
      setDone(true);
    } catch {
      setErr("Could not unsubscribe. Please contact us directly.");
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="unsubscribe-page">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center space-y-4">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
            <Mail size={26} className="text-primary" />
          </div>
          {loading ? (
            <p className="text-sm text-muted-foreground">Loading...</p>
          ) : err ? (
            <>
              <h1 className="text-xl font-outfit font-semibold">Link not valid</h1>
              <p className="text-sm text-muted-foreground">{err}</p>
            </>
          ) : done ? (
            <>
              <CheckCircle2 size={36} className="text-emerald-500 mx-auto" />
              <h1 className="text-xl font-outfit font-semibold">You're unsubscribed</h1>
              <p className="text-sm text-muted-foreground">{contact?.email} will no longer receive marketing emails from us. We're sorry to see you go.</p>
            </>
          ) : (
            <>
              <h1 className="text-xl font-outfit font-semibold">Unsubscribe?</h1>
              <p className="text-sm text-muted-foreground">Click below to stop all marketing emails to <strong>{contact?.email}</strong>.</p>
              <p className="text-xs text-muted-foreground">Booking confirmations and contracts will still be delivered.</p>
              <Button onClick={confirm} variant="destructive" className="w-full" data-testid="unsubscribe-confirm-btn">
                Yes, unsubscribe me
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
